
import { defineComponent, computed, watch, ref } from "vue";
import Multiselect from "@/Components/General/Multiselect.vue";
import axios from "axios";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiChevronDown, mdiClose, mdiLoading } from "@mdi/js";

interface SearchCustomer {
  id: number;
  firstname: string;
  lastname: string;
}

export default defineComponent({
  components: {
    Multiselect,
    SvgIcon,
  },
  props: {
    modelValue: {
      type: Number,
      required: false,
    },
    mode: {
      type: String,
      required: false,
      default: "single",
    },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const getCustomers = async (query: string) => {
      return new Promise(async (resolve, reject) => {
        try {
          const result = await axios.get(route("customers.search"), {
            params: {
              selected: props.modelValue,
              query,
            },
          });

          const customers = result.data.map((customer: SearchCustomer) => {
            return {
              value: customer.id,
              label: `${customer.firstname} ${customer.lastname}`,
            };
          });

          resolve(customers);
        } catch (error) {
          reject(error);
        }
      });
    };

    const value = computed({
      get: (): number => props.modelValue ?? 1,
      set: (v: number) => {
        context.emit("update:modelValue", v);
      },
    });

    return {
      value,
      getCustomers,
      caretIcon: mdiChevronDown,
      clearIcon: mdiClose,
      loadingIcon: mdiLoading,
    };
  },
});
